import { cn } from "./utils/cn";

interface Props {
  size: number;
}

export function Spinner({ size }: Props) {
  return (
    <div
      className={cn(
        "animate-spin border-primary-1 rounded-full border-t-gray-200"
      )}
      style={{ width: size, height: size, borderWidth: size / 6 }}
    />
  );
}
